import React from "react";

// import {TransactionContext} from "../../../../../context";
// import {CustomBadges, TableLoading, TableNullData} from "../../../../../components";

import "./index.scss";
import {
  CustomBadges,
  CustomIcon,
  TableNullData,
  UserInformation,
} from "../../../../../../components";
import utils from "../../../../../../utils";
import {
  GATEWAY,
  PAYER_TYPE,
  PAY_TYPE,
  TRANSACTION_REASON,
  TRANSACTION_STATUS,
} from "../../../../../../values/dropdownItems";
import Context from "../../../../../../context";
import MicroTransaction from "../MicroTransaction";
import Invoice from "../Invoice";
import { useTranslation } from "react-i18next";

type Props = {
  data: any;
};

const Body = ({ data }: Props) => {
  const { requestTransaction, setShowModal, setSelectedTransaction } =
    React.useContext(Context.TransactionsScreen);
  const [openInfoModal, setOpenInfoModal] = React.useState<boolean>(false);
  const docs = data?.data?.result?.docs;

  function onClickInfo() {
    setOpenInfoModal(!openInfoModal);
  }

  function onClickRow(index: number) {
    // setSelectedUserId(index);
    // setShowModal("SHOW");
  }

  const { t } = useTranslation();

  if (!docs || docs?.length <= 0) return <TableNullData />;
  return (
    <>
      <tbody id="find-transaction-body-container">
        {docs?.map((transaction: any, index: number) => {
          let payerInfo: any = {};

          payerInfo = transaction?.payerId;

          return (
            <tr
              key={`files-tr-${index}`}
              onClick={() => onClickRow(transaction?.transactionId?._id)}
            >
              <td onClick={onClickInfo}>
                <div className="table-index-number">
                  {requestTransaction.page === 1
                    ? index + 1
                    : (requestTransaction.page - 1) * 10 + index + 1}
                </div>
              </td>
              <td onClick={onClickInfo} className="table-text">
                {t(
                  PAY_TYPE.find((item) => item.value === transaction?.isDeposit)
                    ?.name as string
                )}
              </td>
              <td onClick={onClickInfo}>
                {transaction?.isDeposit === true && (
                  <UserInformation
                    //avatar={transaction?.driver?.avatar}
                    name={payerInfo?.firstName + " " + payerInfo?.lastName}
                    //lastName={transaction?.payerType}
                    phoneNumber={t(
                      PAYER_TYPE?.find((item) =>
                        transaction?.isDeposit === true
                          ? transaction?.payerType === item.value
                          : transaction?.receiverType === item.value
                      )?.name as string
                    )}
                    hideAvatar
                  />
                )}
              </td>
              <td>
                <UserInformation
                  //avatar={transaction?.driver?.avatar}
                  name={
                    transaction?.student?.firstName +
                    " " +
                    transaction?.student?.lastName
                  }
                  //lastName={transaction?.payerType}

                  avatar={transaction?.student?.avatar}
                />
              </td>
              <td onClick={onClickInfo}>
                {utils.convertNumberToPrice(transaction?.amount)}
                {t("toman")}
              </td>
              <td>
                {utils.convertGregorianToJalali({
                  date: transaction.createdAt,
                  format: "hh:mm -- jYYYY/jMM/jDD",
                })}
              </td>
              <td>
                {t(
                  TRANSACTION_REASON.find(
                    (item) => item.value === transaction.reason
                  )?.name as string
                )}
              </td>
              <td>{transaction?.count}</td>
              <td>
                {transaction.reason !== "SERVICE_SUBSCRIPTION_FROM_WALLET" &&
                  t(
                    GATEWAY.find((item) => item.value === transaction?.getway)
                      ?.name as string
                  )}
                {transaction.reason === "SERVICE_SUBSCRIPTION_FROM_WALLET" &&
                  t("payFromWallet")}
              </td>
              <td>{transaction?.authority}</td>
              <td>{transaction?.company?.companyInformation?.companyName}</td>
              <td>{transaction?.city?.Name}</td>
              <td>
                <CustomBadges
                  title={t(
                    TRANSACTION_STATUS.find(
                      (item) => item.value === transaction.transactionStatus
                    )?.name as string
                  )}
                  type={
                    transaction.transactionStatus === "SUCCESS"
                      ? "success"
                      : transaction.transactionStatus === "PENDING"
                      ? "warning"
                      : "danger"
                  }
                />
              </td>
              <td onClick={onClickInfo}>
                <div className="table-actions-buttons">
                  {transaction.transactionStatus === "SUCCESS" && (
                    <CustomIcon
                      hoverTitle={t("transactionDetail")}
                      icon="fas fa-info-circle"
                      onClick={() => {
                        setShowModal("MICRO_TRANSACTIONS");
                        setSelectedTransaction(transaction);
                      }}
                    />
                  )}
                  <CustomIcon
                    hoverTitle={t("factors")}
                    icon="fas fa-file-pen"
                    onClick={() => {
                      setShowModal("INVOICES");
                      setSelectedTransaction(transaction);
                    }}
                  />
                </div>
              </td>
            </tr>
          );
        })}
      </tbody>
      <MicroTransaction />
      <Invoice />
    </>
  );
};

export default Body;
